import { PropsWithChildren, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { EuiContext } from '@elastic/eui';

import { I18nContext, Language } from './Context';

const mappings: Record<Language, Record<string, string>> = {
  en: {},
  fr: {},
};

export const I18nProvider = ({ children }: PropsWithChildren) => {
  const [language, setLanguage] = useState<Language>('en');
  const i18n = {
    mapping: mappings[language],
  };

  const toggleLanguage = () => {
    setLanguage((prevLanguage) => (prevLanguage === 'en' ? 'fr' : 'en'));
  };

  return (
    <I18nContext.Provider value={{ toggleLanguage }}>
      {/* Empty messages → react-intl falls back to defaultMessage (English). */}
      <IntlProvider locale="en" messages={{}} defaultLocale="en">
        <EuiContext i18n={i18n}>{children}</EuiContext>
      </IntlProvider>
    </I18nContext.Provider>
  );
};
